import { render, staticRenderFns } from "./SchoolList.vue?vue&type=template&id=63691c5b&scoped=true&"
import script from "./SchoolList.vue?vue&type=script&lang=js&"
export * from "./SchoolList.vue?vue&type=script&lang=js&"
import style0 from "./SchoolList.vue?vue&type=style&index=0&id=63691c5b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63691c5b",
  null
  
)

export default component.exports